import React from "react";

import {
    FaUsers,
    FaClipboardList,
    FaQuestionCircle,
    FaBoxes,
    FaShoppingCart,
    FaMoneyBillWave,
} from "react-icons/fa";

import SectionCard from "./SectionCard";

import {
    formatCurrency,
    formatNumber,
} from "../utils/dashboardFormatters";


const BusinessOverview = ({
    customers = {},
    requirements = {},
    queries = {},
    products = {},
    purchases = {},
}) => {

    const items = [
        {
            title: "Customers",
            icon: FaUsers,
            value: formatNumber(
                customers?.totalCustomers
            ),
            subtitle: `${formatNumber(
                customers?.newCustomers
            )} new`,
        },

        {
            title: "Customer Requirements",
            icon: FaClipboardList,
            value: formatNumber(
                requirements?.total
            ),
            subtitle: `${formatNumber(
                requirements?.active
            )} active`,
        },

        {
            title: "Queries",
            icon: FaQuestionCircle,
            value: formatNumber(
                queries?.totalQueries
            ),
            subtitle: `${formatNumber(
                queries?.openQueries
            )} open`,
        },

        {
            title: "Products",
            icon: FaBoxes,
            value: formatNumber(
                products?.totalProducts
            ),
            subtitle: `${formatNumber(
                products?.activeProducts
            )} active`,
        },

        {
            title: "Purchase Bills",
            icon: FaShoppingCart,
            value: formatNumber(
                purchases?.totalBills
            ),
            subtitle: formatCurrency(
                purchases?.purchaseAmount
            ),
        },

        {
            title: "Supplier Balance",
            icon: FaMoneyBillWave,
            value: formatCurrency(
                purchases?.balanceAmount
            ),
            subtitle: `${formatCurrency(
                purchases?.paidAmount
            )} paid`,
        },
    ];


    return (

        <SectionCard
            title="Business Operations"
            subtitle="Quick overview across customers, inventory, queries and purchases."
        >

            <div className="dashboard-business-grid">

                {
                    items.map(
                        (
                            item
                        ) => {

                            const Icon =
                                item.icon;


                            return (

                                <div
                                    key={
                                        item.title
                                    }
                                    className="dashboard-business-card"
                                >

                                    <div className="dashboard-business-icon">

                                        <Icon />

                                    </div>


                                    <div>

                                        <span className="dashboard-business-title">

                                            {
                                                item.title
                                            }

                                        </span>


                                        <strong>

                                            {
                                                item.value
                                            }

                                        </strong>


                                        <small>

                                            {
                                                item.subtitle
                                            }

                                        </small>

                                    </div>

                                </div>

                            );

                        }
                    )
                }

            </div>

        </SectionCard>

    );

};


export default BusinessOverview;